<template>
	<Card>
		<template #content>
		<FileInput
				v-model="form.file"
        accept="application/pdf"
				:label="$t('forms.device.end_of_line_testing_documents_form.add_testing_document')"
				:error-text="form.errors?.file"
				@change="form.validate('file')"
		/>
		</template>

		<template v-if="hasOnSaveListener" #footer>
			<div class="flex justify-end">
				<Button @click="$emit('on-save', form)" :label="$t('forms.common.save')" :disabled="form.processing"/>
			</div>
		</template>
	</Card>
</template>

<script>
import FileInput from "@/Components/FileInput.vue";

export default {
	name: "EndOfLineTestingDocumentsForm",
	components: {
		FileInput,
	},
	props: {
		form: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			file: null,
		}
	},
	computed: {
		hasOnSaveListener() {
			return !!(this.$attrs?.onOnSave);
		},
	},
}
</script>

<style scoped>

</style>